import { query, trackEvent, xenv } from '@didi/webx-js'
import { GlobalEnv } from '../../../index.js'

const getChannelType = () => {
  switch (xenv()) {
    case 'wxmp':
      return 1
    case 'alimp':
      return 2
    case 'passenger':
      return 3
    default:
      return 4
  }
}

// 仅限省钱卡部分使用的埋点事件
export const track = (event_id, name, params = {}) => {
  // console.log('-track', event_id, name, params)
  trackEvent(
    event_id,
    name,
    Object.assign(
      {
        channel_id: getChannelType(),
        uid: GlobalEnv.loginInfo.uid,
        dchn: query().dchn,
      },
      params
    )
  )
}
